module.exports = __webpack_public_path__ + "static/media/nauka-programowania-dla-dzieci-inf1-1.e73e6ff4.png";